import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { UpAndDownButton } from "components/shared/UpAndDown";
import FormHeader from "components/ui/atoms/FormHeader";
import Highlight from "components/ui/atoms/Highlight";

const CreateFormHeader = ({}) => {
  const theme = useTheme();

  return (
    <Highlight color={theme.palette_custom.yellow}>Create sharing</Highlight>
  );
};

const UpdateFormHeader = ({ sharing }) => {
  const theme = useTheme();

  return (
    <>
      <UpAndDownButton value={sharing.id} />
      <Stack sx={{ ml: 1 }}>
        <Highlight color={theme.palette_custom.yellow}>
          {sharing.name}
        </Highlight>
        <Typography variant="caption">
          {`Created at ${new Date(
            Date.parse(sharing.created_at),
          ).toLocaleDateString()}`}
        </Typography>
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          ml: "auto",
        }}
      >
        <Box sx={{ pl: 1 }}>Sharing: {sharing.id}</Box>
      </Box>
    </>
  );
};

const DealSharingFormHeader = ({ formType, onClose, ...props }) => {
  let header;
  if (formType == "create") header = <CreateFormHeader {...props} />;
  if (formType == "update") header = <UpdateFormHeader {...props} />;

  return <FormHeader onClose={onClose}>{header}</FormHeader>;
};

export default DealSharingFormHeader;
